import axios, { AxiosResponse } from "axios";
import { SERVER_URL } from "Constants";
import useAsync, { useAsyncResponse } from "Hooks/useAsync";
import { accountType } from "Models/Enums";
import moment from "moment";

export type OrganisationPlanSummary = {
	accountType: accountType;
	customerSeatsLeft: number;
	trialEndDate: Date | null;
}

export default function useOrganisationPlan(): useAsyncResponse<OrganisationPlanSummary, any> {
	const request = useAsync(async () => {
		const response = await axios.get<{
			accountType: accountType;
			customerCount: number;
			maxCustomerCount: number;
			trialEndDate: Date;
		}>(`${SERVER_URL}/api/entity/OrganisationEntity/plan-summary`);

		const data = response.data;

		const parsedData: OrganisationPlanSummary = {
			accountType: data.accountType,
			customerSeatsLeft:  data.maxCustomerCount - data.customerCount,
			trialEndDate: moment(data.trialEndDate).toDate()
		};

		return parsedData;
	}, []);

	return request;
}